import {
  ProjectTitleCell,
  ProjectDescriptionCell,
  ProjectDevicesCell,
  ProjectUsersCell,
  ProjectDateCell,
  ProjectLogsCell,
  ProjectEditCell
} from './project';

export const projectTableHeadMap = {
  name: ProjectTitleCell,
  description: ProjectDescriptionCell,
  devices: ProjectDevicesCell,
  users: ProjectUsersCell,
  date: ProjectDateCell,
  trail: ProjectLogsCell,
  edit: ProjectEditCell
};
